import { getQuoteProperty } from 'quotes-ui-lib/utils/utils';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { getIsPublished } from 'quotes-ui-lib/utils/status';
import { memo, useMemo } from 'react';
import UIConfirmModal from 'UIComponents/dialog/UIConfirmModal';
import UILoadingButton from 'UIComponents/button/UILoadingButton';
import { jsx as _jsx } from "react/jsx-runtime";
const DeleteQuoteModal = ({
  quote,
  isOpen,
  loading,
  onConfirm,
  onReject
}) => {
  const quotePublished = getIsPublished(quote);
  const quoteTitle = getQuoteProperty(quote, 'hs_title');
  const title = useMemo(() => /*#__PURE__*/_jsx(FormattedMessage, {
    message: "quotesUiLib.deleteQuoteModal.title",
    options: {
      title: quoteTitle
    }
  }), [quoteTitle]);
  const description = useMemo(() => /*#__PURE__*/_jsx("div", {
    className: "m-top-4",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: quotePublished ? 'quotesUiLib.deleteQuoteModal.descriptionPublishedQuote' : 'quotesUiLib.deleteQuoteModal.description'
    })
  }), [quotePublished]);
  if (!isOpen) {
    return null;
  }
  const confirmLabel = /*#__PURE__*/_jsx(FormattedMessage, {
    message: "quotesUiLib.deleteQuoteModal.confirm"
  });
  const cancelLabel = /*#__PURE__*/_jsx(FormattedMessage, {
    message: "quotesUiLib.deleteQuoteModal.cancel"
  });
  return /*#__PURE__*/_jsx(UIConfirmModal, {
    "data-test-id": "delete-quote-modal",
    message: title,
    size: "auto",
    use: "danger",
    confirmUse: "danger",
    description: description,
    ConfirmButton: UILoadingButton,
    confirmButtonProps: {
      loading
    },
    onConfirm: onConfirm,
    onReject: onReject,
    confirmLabel: confirmLabel,
    rejectLabel: cancelLabel
  });
};
export default /*#__PURE__*/memo(DeleteQuoteModal);